import React, { Component } from 'react';
import { observer } from 'mobx-react';

import IslandScreen from './Island/IslandScreen';

import heroStore from '../stores/hero';

import BuildingScreen from './BuildingScreen';

import { inBuilding } from '../utils/warriorUtils';

@observer
export default class Location extends Component<{}> {
  render() {
    return inBuilding(heroStore.hero) ? <BuildingScreen /> : <IslandScreen />;
  }
}
